import { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'

import { Nullable } from 'clickNgo/models/utils'
import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'
import { selectQBRSelectedDocumentInitiatives } from 'partner360/features/QBR/selectors/selectQBRSelectedDocumentInitiatives'
import { IQbrDocumentInitiative } from 'partner360/models/qbr/iQbrDocumentInitiative'

import { fetchAvailableInitiatives } from '../api/fetchAvailableInitiatives'

export const useAvailableInitiatives = (documentId: Nullable<number>) => {
  const [isLoading, setIsLoading] = useState(false)
  const [availableInitiatives, setAvailableInitiatives] = useState<IQbrDocumentInitiative[]>([])

  const qbrDocumentInitiatives = useSelector(selectQBRSelectedDocumentInitiatives)

  const filteredAvailableInitiatives = useMemo(() => {
    return availableInitiatives.filter((availableInitiative) => {
      if (!qbrDocumentInitiatives.length) {
        return true
      }

      const match = qbrDocumentInitiatives.find(
        (addedInitiative) => addedInitiative.EntryId === availableInitiative.EntryId
      )

      return !match
    })
  }, [qbrDocumentInitiatives, availableInitiatives])

  const initiativesCrud = useMemo(() => {
    return new Crud({
      fetcher: new Static(filteredAvailableInitiatives),
      keyField: 'EntryId',
    })
  }, [filteredAvailableInitiatives])

  useEffect(() => {
    if (!documentId) {
      return
    }

    setIsLoading(true)
    fetchAvailableInitiatives(documentId)
      .then(setAvailableInitiatives)
      .finally(() => setIsLoading(false))
  }, [documentId])

  return {
    isLoading,
    initiativesCrud,
    availableInitiatives: filteredAvailableInitiatives,
  }
}
